import { render, staticRenderFns } from "./crm-chart.vue?vue&type=template&id=5cd933c3&"
import script from "./crm-chart.vue?vue&type=script&lang=js&"
export * from "./crm-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports